<template>
    <p v-for="(error, index) in errors" :key="index" class="forms__field_error">
        {{ error }}
    </p>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
    errors?: any;
}

const props = withDefaults(defineProps<Props>(), {
    errors: [],
});

const flatten = (errors: any) => {
    if (Array.isArray(errors)) {
        return errors;
    }

    if (typeof errors === 'object') {
        return Object.values(errors).reduce((acc, error) => {
            if (typeof error === 'string') {
                acc.push(error);
            } else {
                acc = acc.concat(Object.values(error));
            }
            return acc;
        }, []);
    }

    return [errors];
};

const errors = computed(() => {
    return flatten(props.errors);
});
</script>
